import script from "./InstallationTable.vue?vue&type=script&setup=true&lang=js"
export * from "./InstallationTable.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__